import { GetHistoryCashbackTC, GetHistoryTC } from './history.thunks'

const historyAsyncActions = {
  GetHistoryCashbackTC,
  GetHistoryTC,
}

export default historyAsyncActions
